import { render, staticRenderFns } from "./caiGouIndex.vue?vue&type=template&id=12c9b13b&scoped=true"
import script from "./caiGouIndex.vue?vue&type=script&lang=js"
export * from "./caiGouIndex.vue?vue&type=script&lang=js"
import style0 from "./caiGouIndex.vue?vue&type=style&index=0&id=12c9b13b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9b13b",
  null
  
)

export default component.exports